import { connect } from "react-redux";
import { cartsChanged } from "../../../../store/action/cart";
import CartService from "../../../../services/cart/Cart";
import Card from "../../../../components/card";
import Checkbox from "../../../../components/checkbox/Checkbox";

import {
  Col,
  Div,
  CardLink,
  PaymethodIcon,
  PaymethodTitle,
  Container,
} from "./style";

const Item = (props) => {
  const { data, carts, index, theme, cartsChanged } = props;

  const selectPaymethod = (name = "paymethod_id", value = data, e) => {
    if (e) {
      e.preventDefault();

      name = "paymethod_id";
      value = data;
    }

    if (data.status) {
      CartService.changed(carts, name, value?.id, cartsChanged);
    }
  };

  return (
    <Col className="col-6">
      <Container sel={index % 2}>
        <CardLink href="/" onClick={(e) => selectPaymethod(false, false, e)}>
          <Card className="pt-3 pb-2 px-2 text-right mx-1">
            <Div className="text-center payment-height">
              <PaymethodIcon
                className={`${data.icon_text} f-30`}
                theme={theme}
              ></PaymethodIcon>
              <PaymethodTitle className="mt-2" theme={theme}>
                {data.title}
              </PaymethodTitle>
              {data.status ? (
                <Checkbox
                  className="mt-2"
                  onChange={selectPaymethod}
                  checked={carts?.paymethod_id === data.id ? true : false}
                />
              ) : (
                <PaymethodTitle className="mt-3 f-12 color-red">غیرفعال می باشد</PaymethodTitle>
              )}
            </Div>
          </Card>
        </CardLink>
      </Container>
    </Col>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
    carts: state.carts.carts,
  };
};

export default connect(mapStateToProps, { cartsChanged })(Item);
